import { useState } from 'react';
import {
  Training,
  Theme,
  Evaluation,
  Flag,
  DuoToneCourseFilled,
  DuoToneAssessmentFilled,
  DuoToneVacancyFilled,
} from '@teo/components/icons';
import { Button, IconTile, ProgressBar } from '@teo/components';
import { useGet } from '@/query/fetchHooks';
import { useTranslation } from 'react-i18next';
import { parseCourseType } from '@/util';
import { categoriesIcon } from '@/components/LearningPath/util';
import i18n from 'i18next';

export const ActiveCardPreview = ({
  lpgroupId,
  selectNode,
  auth,
  allCategories,
}) => {
  const { t } = useTranslation();
  const [data, setDate] = useState(null);
  const [courseInfo, setCourseInfo] = useState(null);

  const examplePathCourse = `/${i18n.language}/create/${auth?.user?.activeOrganisationId}`;
  const examplePathTraining = `/${i18n.language}/create/${auth?.user?.activeOrganisationId}/learning-paths/${lpgroupId}`;
  useGet(`/coursedetail/${selectNode?.objectId}`, {
    enabled: selectNode?.type === 'course',
    onSuccess: async (res) => {
      setDate(res?.data || null);
    },
  });

  useGet(`/courseinfo/${selectNode?.objectId}`, {
    enabled: selectNode?.type === 'course',
    retry: false,
    onSuccess: (result) => {
      setCourseInfo(result?.data || {});
    },
  });

  useGet(`/training/${selectNode?.objectId}`, {
    enabled: selectNode?.type === 'training',
    onSuccess: async (res) => {
      setDate(res?.data || null);
    },
  });

  useGet(`/learningpath/${selectNode?.objectId}`, {
    enabled: selectNode?.type === 'learningpath',
    onSuccess: async (res) => {
      setDate(res?.data || null);
    },
  });

  let Icon;
  if (selectNode?.tags && selectNode?.type === 'learningpath') {
    const learningpathTags = allCategories?.find(
      (el) => el?.label === selectNode?.tags.split(':')[1]
    );
    Icon = categoriesIcon(learningpathTags?.icon);
  } else {
    Icon = Theme;
  }

  if (!selectNode) return null;

  return (
    <div
      className="absolute bottom-8 left-1/2 z-[1] w-full max-w-[720px] px-4"
      style={{
        transform: 'translate(-50%, 0)',
      }}
    >
      <div className="flex w-full max-w-[720px] rounded-xl bg-white p-5 drop-shadow-m">
        <div className="pr-5">
          <IconTile
            Icon={
              selectNode.subType === 'training'
                ? Training
                : selectNode.subType === 'learningpath'
                ? Icon
                : selectNode.subType === 'milestone'
                ? Flag
                : selectNode.subType === 'evaluation'
                ? Evaluation
                : selectNode.subType === 'course'
                ? DuoToneCourseFilled
                : selectNode.subType === 'assessment'
                ? DuoToneAssessmentFilled
                : selectNode.subType === 'leervacature'
                ? DuoToneVacancyFilled
                : DuoToneCourseFilled
            }
            imageUrl={selectNode.picture}
            color={
              selectNode.subType === 'training'
                ? 'green'
                : selectNode.subType === 'learningpath'
                ? 'dark_blue'
                : selectNode.subType === 'milestone'
                ? 'blue'
                : selectNode.subType === 'evaluation'
                ? 'purple'
                : selectNode.subType === 'course'
                ? 'yellow'
                : selectNode.subType === 'assessment'
                ? 'red'
                : selectNode.subType === 'leervacature'
                ? 'yellow'
                : 'yellow'
            }
            size="small_lg"
            className={
              selectNode.subType === 'course' || selectNode.subType === 'import'
                ? 'fill-primary-06 text-primary-01'
                : selectNode.subType === 'assessment'
                ? 'fill-tint-red-dark text-tint-red-light'
                : selectNode.subType === 'leervacature'
                ? 'fill-error-04 text-error-04'
                : ''
            }
          />
        </div>
        <div className="flex w-full flex-col">
          <div className="flex items-start">
            <div className="flex flex-1 flex-col gap-1">
              <p className="text-sm text-grey-05">
                {selectNode?.subType === 'training'
                  ? t('pages.learning_path.training')
                  : selectNode?.subType === 'learningpath'
                  ? t('pages.learning_path.theme')
                  : selectNode?.subType === 'milestone'
                  ? t('pages.learning_path.milestone')
                  : selectNode?.subType === 'evaluation'
                  ? t('pages.learning_path.evaluation')
                  : selectNode?.subType === 'course'
                  ? t('links.course')
                  : selectNode?.subType === 'assessment'
                  ? t('links.assessment')
                  : selectNode?.subType === 'leervacature'
                  ? t('links.vacancy')
                  : t('links.course')}
              </p>
              <p className={` text-left text-base font-semibold text-black  `}>
                {selectNode?.name}
              </p>
            </div>
            <Button
              size="sm"
              variant="outline"
              onClick={() => {
                if (selectNode?.type === 'course') {
                  window.open(
                    selectNode.subType !== 'import'
                      ? `${examplePathCourse}/${parseCourseType(
                          data?.publicationCourseType
                        )}/${data?.coursecontentId}/preview?les=0&new_tab=true`
                      : `${examplePathCourse}/${parseCourseType(
                          data?.publicationCourseType
                        )}/${data?.coursecontentId}`,
                    '_blank'
                  );
                }

                if (selectNode?.type === 'training') {
                  window.open(
                    `${examplePathTraining}/${selectNode?.subType}/${selectNode?.objectId}/preview`,
                    '_blank'
                  );
                }
                if (selectNode?.type === 'learningpath') {
                  window.open(
                    `${examplePathTraining}/theme/${selectNode?.objectId}/preview`,
                    '_blank'
                  );
                }
              }}
            >
              {selectNode?.subType === 'training'
                ? t('pages.lp_landing.view_training')
                : selectNode?.subType === 'learningpath'
                ? t('pages.lp_landing.view_theme')
                : selectNode?.subType === 'milestone'
                ? t('pages.lp_landing.view_milestone')
                : selectNode?.subType === 'evaluation'
                ? t('pages.lp_landing.view_evaluation')
                : selectNode?.subType === 'course'
                ? t('pages.lp_landing.view_course')
                : selectNode?.subType === 'assessment'
                ? t('pages.lp_landing.view_assessment')
                : selectNode?.subType === 'leervacature'
                ? t('pages.lp_landing.view_vacancy')
                : t('pages.lp_landing.view_course')}
            </Button>
          </div>

          {selectNode?.type === 'course' && (
            <div className="my-2 flex items-center">
              <div className="flex w-full">
                <ProgressBar
                  max={100}
                  value={0}
                  className={`h-1 overflow-hidden rounded-lg`}
                />
              </div>
              <span className="pl-3 text-xs text-grey-06">{0}%</span>
            </div>
          )}
          <div className="flex">
            {selectNode?.type === 'course' && (
              <p
                className="text-sm text-grey-08 sm:text-base"
                dangerouslySetInnerHTML={{
                  __html:
                    data?.hasCustomLanding && courseInfo?.abstract
                      ? courseInfo?.abstract
                      : data?.description,
                }}
              />
            )}

            {selectNode?.type === 'training' && (
              <p
                className="text-sm text-grey-08 sm:text-base"
                dangerouslySetInnerHTML={{
                  __html: data?.trainingDescription,
                }}
              />
            )}

            {selectNode?.type === 'learningpath' && (
              <p
                className="text-sm text-grey-08 sm:text-base"
                dangerouslySetInnerHTML={{
                  __html: data?.lpDescription,
                }}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
